import type { MessageRead } from '../types';

/**
 * True when every current event chat member except the sender has a read receipt.
 * If there are no other members, the message is treated as fully seen.
 */
export function isMessageSeenByAllMembers(
  senderId: string,
  readers: MessageRead[],
  eligibleMemberIds: string[]
): boolean {
  const eligibleOthers = [...new Set(eligibleMemberIds.filter((id) => id && id !== senderId))];
  if (eligibleOthers.length === 0) return true;

  const readerIds = new Set(
    readers.filter((r) => r.user_id && r.user_id !== senderId).map((r) => r.user_id)
  );

  return eligibleOthers.every((id) => readerIds.has(id));
}
